<template>
    <div>
        <!-- TODO 스마트 피팅 반영 -->
        <div class="sub_title">
            스마트 피팅 이미지 정보
        </div>
        <div class="sub_title notion_title">
            *해당 상품을 착용하고 있는 모델샷 등록 바랍니다.
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="400px">
                    <col>
                </colgroup>
                <thead>
                <tr>
                    <th>스마트 피팅 이미지</th>
                    <th class="text_left">스마트 피팅시 사용되는 이미지 입니다.</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td colspan="2">
                        <div>
                            <el-upload
                                action=""
                                class="avatar-uploader"
                                list-type="picture-card"
                                :auto-upload="false"
                                :show-file-list="false"
                                :file-list="smartFittingImage"
                                :on-change="handleFileChange"
                            >
                                <i class="el-icon-plus avatar-uploader-icon"
                                   v-if="smartFittingImage.length === 0"></i>
                                <div v-else >
                                    <img :src="smartFittingImage[0].org_url" alt="" class="avatar">
                                </div>
                            </el-upload>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    name: "ItemSmartFittingLayout",
    mixins: [alertMixins],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,}
    },
    data() {
        return {
            smartFittingImage: [],
            validatorArr: [],
            imageMaxSize: 20 * 1024 * 1024,
            imageSizeError: '20MB',
        }
    },
    created() {
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
        this.setImportLayoutNames('ItemSmartFittingLayout')
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.smartFittingImage = this.itemData.smartFittingImage.slice();
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        regExp(str) {
            let reg = /[\{\}\[\]\/?,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\" ]/gi
            if (reg.test(str)) {
                return str.replace(reg, "_");
            } else {
                return str
            }
        },
        handleFileChange(file, fileList) {
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');

            file.name = this.regExp(file.name)
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 ' + maxSize + '를 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {
                file.org_url = file.url;
                let optionFile = Object.assign({}, file);
                if (this.smartFittingImage.length > 0 && this.smartFittingImage[0].hasOwnProperty('a_idx') && this.smartFittingImage[0].a_idx != null) {
                    file.a_idx = this.smartFittingImage[0].a_idx;
                }
                this.smartFittingImage[0] = file;
                this.$forceUpdate();
                this.parentChange('smartFittingImage', this.smartFittingImage);
            }
        },
        checkValidator() {
            // this.$validate(['name', 'link', 'manageCode', 'price'])
        },
    },
    watch: {},
    validators: {

    },
}
</script>

<style scoped>

</style>
